export default "__VITE_ASSET__99wDqTjM__"